export default __webpack_public_path__ + "static/garniewski-a90acca1fb4e731940eef14ca1fdfbd3.jpg";